import { useMemo } from 'react';
import { useAppFlagStore } from '@frontend/shared';
import { ONBOARDING_DASHBOARD_FF } from '../constants';

export const useHasOnboardingV2FeatureFlag = ({ locationIds }: { locationIds: string[] }) => {
  const { getFeatureFlag } = useAppFlagStore();

  return useMemo(() => {
    const featureFlag = getFeatureFlag({ flagName: ONBOARDING_DASHBOARD_FF, locationIds })?.[0];

    return {
      isEnabled: !!featureFlag?.value,
      isLoading: featureFlag === undefined,
    };
  }, [getFeatureFlag, locationIds]);
};
